export default __webpack_public_path__ + "static/media/paper-pulse-white.661dd7a3.svg";